{
  "loginTitle": "Login",
  "emailPlaceholder": "Email",
  "passwordPlaceholder": "Password",
  "loginButton": "Login",
  "forgotPassword": "Forgot your password?",
  "signupPrompt": "Don't have an account?",
  "signupLink": "Sign up",
  "loading": "Loading...",
  "emailVerifiedSuccessfully": "Email verified successfully!",
  "resetPasswordTitle": "Reset Password",
  "resetPasswordButton": "Send Reset Link",
  "passwordReset": {
    "success": "If an account exists with this email, you will receive password reset instructions.",
    "failed": "Could not send password reset email.",
    "error": "An error occurred while requesting password reset. Please try again."
  },
  "passwordResetSuccess": "Your password has been reset successfully. Please login with your new password.",
  "passwordResetInvalid": "Invalid password reset link. Please request a new one.",
  "passwordResetError": "An error occurred while resetting your password. The link may have expired.",
  "invalidCredentials": "Email or password is incorrect.",
  "networkError": "Could not connect to the server. Please check your connection and try again.",
  "serverUnavailable": "Server unavailable at the moment. Please try again shortly.",
  "loginError": "An error occurred during login. Please try again.",
  "privacyInfo": {
    "title": "Your data is protected",
    "body": "By continuing, you agree to the",
    "termsLink": "Terms of Service",
    "privacyLink": "Privacy Policy"
  },
  "magicLink": {
    "cta": "Sign in with an email link",
    "sentTitle": "Check your email",
    "sentBody": "If an account exists for {{email}}, we've sent a sign-in link. Open the link to sign in — it's valid for 15 minutes and can be used only once.",
    "sentBodyNoEmail": "If an account exists for that email, we've sent a sign-in link. Open the link to sign in — it's valid for 15 minutes and can be used only once.",
    "resend": "Resend link",
    "resent": "Link sent again.",
    "backToLogin": "Back to sign in",
    "emailRequired": "Enter your email to receive a sign-in link.",
    "requestError": "We couldn't send the link. Please try again."
  }
} 